<template>
    <template-layout>
        <div class="py-12 px-4">
            <nav class="mb-2 flex justify-between">
                <h1 class="text-2xl text-theme-1">
                ข้อมูลผู้ใช้งาน
                </h1>
                <FormModal :viewState="viewData" @closeModal="viewData=null"/>
            </nav>
            <div class="grid grid-cols-12 gap-6">
                <div class="col-span-12 md:col-span-4 lg:col-span-3">
                    <UsersFilter/>
                </div>
                <div class="col-span-12 md:col-span-8 lg:col-span-9">
                    <FilterSummary :items="filterSummaryStore"/>
                    <UserDatatable :filter="filterValue" @setPassword="resetData=$event" @viewState="viewData=$event"/>
                </div>
            </div>
        </div>
        <ResetModal :resetStateData="resetData" @closeModal="resetData=null"/>
    </template-layout>
</template>

<script setup>
import { ref, computed, reactive } from "vue";
import TemplateLayout from "@/layouts/side-menu/Main.vue";
import FilterSummary from "@/components/filter-summary/index.vue";
import UsersFilter from "@/components/filter-search/UsersFilter"
import FormModal from "./container/UserFormModal.vue";
import UserDatatable from "./container/UserDatatable.vue"
import ResetModal from "./container/ResetPasswordModal.vue"
import { useStore } from "vuex";

const store = useStore();
const filterSummaryStore = computed(
  () => store.getters["usersFilter/getFilterSummaryArray"]
);
const filterValue = computed(() => store.getters["usersFilter/getFilterForApi"]);
const breadcrumbComputed = reactive([{
  name: "ข้อมูลผู้ใช้งาน",
  active: true
}])
const viewData = ref(null)
const resetData = ref(null)


</script>

<style>

</style>